<template>
<AppDialog :is-open="isDialogOpened"
           size="l"
           :ok-text="$t('common.confirm')"
           @ok="confirm"
           @cancel="closeDialog"
>
  <template #title>{{ $t('project.checklist.dialogs.ChecklistStatusDialogDeleteConfirmation.dialogTitle', { statusLabel: status.label }) }}</template>
  <template #body>
    <v-row>
      <v-col class="text--primary">
        {{ $t('project.checklist.dialogs.ChecklistStatusDialogDeleteConfirmation.dialogText') }}
      </v-col>
    </v-row>
  </template>
</AppDialog>
</template>

<script>
import AppDialog from '@/common/dialogs/AppDialog.vue'
import { dialogMixin } from '@/mixins/dialogMixin'
export default {
  name: 'ChecklistStatusDialogDeleteConfirmation',
  components: { AppDialog },
  mixins: [dialogMixin],
  emits: ['confirm'],
  props: {
    status: {
      type: Object,
      required: true,
    },
  },
  methods: {
    confirm () {
      this.$emit('confirm')
      this.closeDialog()
    },
  },
}
</script>
